import { dataSoundWave } from 'dls-icons-data'
import { createIcon } from '../common'

const IconSoundWave = /*#__PURE__*/createIcon(dataSoundWave)
export default IconSoundWave
